<template>
  <main class="pt-6 sm:pt-2">
    <template v-if="isLoading">
      <UtilsSkeletonLoading class="w-full h-20" />
      <UtilsSkeletonLoading class="w-full mb-5 h-12" />
    </template>
    <template v-else>
      <div class="w-full sticky top-[63px] bg-white z-10 pt-3 md:pt-4">
        <div class="container mx-auto flex overflow-auto justify-between">
          <div
            v-for="(tab, index) in types.data"
            :id="tab.attributes.anchor"
            :key="index"
            class="border-b-2 hover:border-primary-primary hover:font-medium text-bw-600 hover:text-primary-primary cursor-pointer py-2.5 px-8 tab-type text-center"
            :class="
              activeTabId === tab.attributes.anchor
                ? 'font-medium text-primary-primary border-primary-primary'
                : 'border-transparent'
            "
            @click="selectTab(index, tab.attributes.anchor)"
          >
            {{ tab.attributes.tab_title }}
          </div>
        </div>
      </div>
      <section
        v-for="susType in types.data"
        :id="susType.attributes?.anchor"
        :key="susType.id"
        ref="itemRefs"
        class="py-6 md:py-10 type-section md:last:pb-15"
      >
        <div class="container mx-auto">
          <h2
            class="text-center sm:text-left section-heading sm:w-full mx-auto sm:mx-0 mb-5"
          >
            {{ susType.attributes?.title }}
          </h2>
          <div
            class="text-base w-full md:w-2/3 font-normal"
            v-html="susType.attributes?.description"
          ></div>
          <SustainabilityCardList :type-id="susType.id" />
        </div>
      </section>
    </template>
  </main>
</template>

<script setup>
// VARIABLE DECLARATION
const isLoading = ref(true)
// const route = useRoute()

const tabs = ref([])
const itemRefs = ref([])
const susObserve = ref(null)

const activeTabId = ref()

// METHODS
const { data: types, pending } = await useSuitmediaApiData(
  `/api/sustainability-types`,
  {
    query: {
      populate: '*',
      'sort[0]': 'id:desc'
    }
  }
)
isLoading.value = pending.value
for (let index = 0; index < types.value.data.length; index++) {
  tabs.value.push(types.value.data[index].attributes.anchor)
}

const selectTab = (index, id) => {
  activeTabId.value = id
  itemRefs.value[index].scrollIntoView({ block: 'center', behavior: 'smooth' })
}

onMounted(() => {
  susObserve.value = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          activeTabId.value = entry.target.id
        }
      })
    },
    {
      threshold: 1
      // rootMargin: '-250px 0px'
    }
  )

  document.querySelectorAll('.type-section').forEach(item => {
    susObserve.value.observe(item)
  })
})

onUnmounted(() => {
  susObserve.value.disconnect()
})
</script>

<style lang="scss" scoped>
.card-img {
  position: relative;
  padding-bottom: calc(210 / 373) * 100%;
  display: block;
}

.type-section {
  &:first-child {
    padding-top: 0px;
  }

  &:nth-child(odd) {
    background: #f9f9f9;
  }
}
</style>
